/* eslint-disable */

const trailers = function() {
  const $ = require('jquery');
  window.jQuery = window.$ = $; // You expose jQ as a global object

  const Slick = require('slick-carousel');
  $(document).ready(function(){
    $('.js-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      dots: true,
      infinite: true,
      speed: 300,
      swipe: true,
      appendArrows: $('.c-slider__arrows'),
      appendDots: $('.c-slider__bullets'),
      prevArrow: '<button type="button" class="c-slider__prev"></button>',
      nextArrow: '<button type="button" class="c-slider__next"></button>',
   });
  });
};
module.exports = trailers;
/* eslint-enable */
